<header>
  <div class="navbar-web">
    <div class="navbar-landing-container">
      <a href="/customer" class="title-link">
        <div class="header-title">
          <img class="navbar-icon" src="assets/img/logo-01.png" alt="nav-icon">
        </div>
      </a>
      <div class="links-container">
        <a class="navbar-link"
          routerLink="./landing"
          routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }">Home</a>
        <a class="navbar-link"
          routerLink="./create"
        routerLinkActive="active">Request Service</a>
        <a class="navbar-link"
          routerLink="./track"
        routerLinkActive="active" >Track Request</a>
        <div class="navbar-link"
        (click)="showLoginModal = true;">Contractor Log In</div>
      </div>
    </div>
  </div>
  <div class="navbar-mobile">
    <div class="navbar-landing-container">
      <a href="/customer" class="title-link">
        <img class="navbar-icon" src="assets/img/logo-01.png" alt="nav-icon">
      </a>
      <div style="flex: 1;"></div>
      <img class="navbar-toggle"
        src="/assets/img/icons/burger_menu.svg"
        alt="nav-icon"
        (click)="showDropdown=!showDropdown" />
      </div>
      @if (showDropdown) {
        <div class="navbar-menus">
          <a routerLink="./landing"
            routerLinkActive="active"
          (click)="showDropdown = false;">Home</a>
          <a routerLink="./create"
            routerLinkActive="active"
          (click)="showDropdown = false;">Request Service</a>
          <a routerLink="./track"
            routerLinkActive="active"
          (click)="showDropdown = false;">Track Request</a>
            <div (click)="showDropdown=false;
                          showLoginModal = true;">Contractor Log In</div>
        </div>
      }
    </div>
    @if (showDropdown) {
      <div class="mobile-cover"
        (click)="showDropdown = false;"
        >
      </div>
    }
  </header>
  <customer-confirm-modal
    [visible]="showLoginModal"
    [title]="'Contractor login'"
    [message]="'Please note this is intended for Private Electrical Contractors Certified by Meralco (PECCBM) only'"
    [confirmText]="'Login'"
    [cancelText]="'Cancel'"
    (onConfirm)="onLogin()"
    (onDismiss)="showLoginModal = false">
  </customer-confirm-modal>
